import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SellerRoutingModule } from './seller-routing.module';
import { SafetyboxComponent, BrowserequestComponent } from './index';
import { ProfileComponent } from './profile/profile.component';
import { SellerApiService } from './service/seller-api.service';
import { ScrollEventModule } from 'ngx-scroll-event';
import { FileDropModule } from 'ngx-file-drop';
import {CalendarModule} from 'primeng/calendar';
import {EditorModule} from 'primeng/editor';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {MultiSelectModule} from 'primeng/multiselect';

// Google Map set up
// https://angular-maps.com/guides/getting-started/
import { AgmCoreModule } from '@agm/core';
import { ManageProjectsComponent } from './manage-projects/manage-projects.component';
import { OrderByPipe, ReversePipe, TruncatePipe } from './orderby.pipe';
import { CustomMinDirective } from './custom-min-validator.directive';
import { CustomMaxDirective } from './custom-max-validator.directive';
import { SharedModule } from '../shared/shared.module';
import { KitchenService } from './service/kitchen.service';
import { KitchenComponent } from './sub-component/kitchen/kitchen.component';
import { KitchenDetailsComponent } from './sub-component/kitchen/kitchen-details/kitchen-details.component';
import { KitchenScopeComponent } from './sub-component/kitchen/kitchen-scope/kitchen-scope.component';
import { KitchenAttachSafetyComponent } from './sub-component/kitchen/kitchen-attach-safety/kitchen-attach-safety.component';
import { KitchenAttachBrowseComponent } from './sub-component/kitchen/kitchen-attach-browse/kitchen-attach-browse.component';
import { CommonPdfService } from './service/common-pdf.service';
import { CommonComponent } from './sub-component/common/common.component';
import { CommonScopeComponent } from './sub-component/common/common-scope/common-scope.component';
import { CommonDetailsComponent } from './sub-component/common/common-details/common-details.component';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '../../environments/environment';
import { CommonAttachSafetyComponent } from './sub-component/common/common-attach-safety/common-attach-safety.component';
import { CommonAttachBrowseComponent } from './sub-component/common/common-attach-browse/common-attach-browse.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { BuyerInfoComponent } from './sub-component/buyer-info/buyer-info.component';
import { CommonIntProjectComponent } from './sub-component/internal-project/common-int-project/common-int-project.component';

@NgModule({
  imports: [
    AgmCoreModule.forRoot({
      apiKey: environment.googlemapapikey,
      libraries: ['places']
    }),
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    HttpModule,
    SellerRoutingModule,
    ScrollEventModule,
    FileDropModule,
    CalendarModule,
    EditorModule,
    AutoCompleteModule,
    SharedModule,
    MultiSelectModule,
    NgxStripeModule.forRoot(environment.stripeKey),
  ],
  declarations: [SafetyboxComponent,
    BrowserequestComponent, ProfileComponent, ManageProjectsComponent,
    OrderByPipe, ReversePipe, TruncatePipe, KitchenDetailsComponent, KitchenScopeComponent,
    CustomMinDirective, CustomMaxDirective, KitchenComponent, KitchenAttachSafetyComponent,
    KitchenAttachBrowseComponent, CommonComponent, CommonScopeComponent,
    CommonDetailsComponent, CommonAttachSafetyComponent, CommonAttachBrowseComponent, BuyerInfoComponent, CommonIntProjectComponent],
  providers: [SellerApiService, KitchenService, CommonPdfService, DatePipe, TranslateService]
})
export class SellerModule { }



// WEBPACK FOOTER //
// ./src/app/seller/seller.module.ts